import { useTranslation } from 'react-i18next';
import { TbArrowRight } from 'react-icons/tb';

import ContactVisual from "./ContactVisual";
import CustomButton from 'src/components/customButton/CustomButton';

const ContactSection = () => {
    const { t } = useTranslation("home");

    return (
        <section className="relative py-16 sm:py-24 lg:py-28">
            <div className="container">
                <div
                    data-aos="fade-up"
                    className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-primary-10 via-white to-primary-50 p-5 ring-1 ring-primary-100 sm:p-8 lg:p-12"
                >
                    <div aria-hidden className="pointer-events-none absolute -end-24 -top-24 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl" />
                    <div aria-hidden className="bg-dots pointer-events-none absolute bottom-6 end-6 hidden h-32 w-48 text-primary-200 lg:block" />

                    <div className="relative grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
                        {/* Visual */}
                        <div className="relative mx-auto w-full max-w-md lg:max-w-[460px]">
                            <ContactVisual />
                        </div>

                        {/* Content */}
                        <div className="flex flex-col items-center px-1 pb-4 text-center sm:px-6 lg:items-start lg:px-0 lg:pb-0 lg:text-start">
                            <div className="eyebrow mb-3 rtl:mb-4">
                                {t("contact.sub_title")}
                            </div>
                            <h3 className="section-title mb-4 lg:text-[2.75rem]">{t("contact.title")}</h3>
                            <p className="global-p mb-8 max-w-xl">{t("contact.description")}</p>
                            <CustomButton
                                text={
                                    <>
                                        {t("contact.btn")}
                                        <TbArrowRight className="h-5 w-5 transition-transform duration-300 rtl:rotate-180 ltr:group-hover:translate-x-1 rtl:group-hover:-translate-x-1" />
                                    </>
                                }
                                theme="primary"
                                to='https://wa.me/218924560537'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
